import { useSyncExternalStore } from 'react'

/**
 * Ambient connectivity flag for the offline banner. Backed by the browser's
 * `online`/`offline` events + `navigator.onLine`.
 *
 * Advisory only — `navigator.onLine === false` can be a transient false
 * negative and `true` never guarantees the server is reachable. So this drives
 * a *banner* (context), never a hard gate on score entry: a wrong reading must
 * not block a player who can actually save. Saves are always attempted and
 * bounded by the Apollo client's `operationTimeoutMs`.
 */
const subscribe = (onChange: () => void): (() => void) => {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

export const useOnlineStatus = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true
  )
